var routeMapElement: CDN.Map.Map;
var layerGroups: {
	id: number,
	old: any[],
	newv2: any[],
	newv1?: any[],
	registration?: string,
	datetime?: string,
	positions?: CDN.API.MapRouting.v1.PointSegment[],
	RefTripRouteTest_Id?: number;
}[] = [];
var layerGroupPos: number = 0;
var lastGroupToggle: 'all' | 'old' | 'new_v1' | 'new_v2' = 'all';
var offset: number = 0;
var srcOffset: number = null;
var mapCirclePositions: CDN.Map.FeatureOptions[] = [];
var currentPos = 0;
var lastSourceId = "";
var loggedUserToken: string = '';
var loggedProducts: CDN.API.User.v1.LoginResultProduct[] = [];

CDN.requireOnce([
	{ code: CDN.PackageCode.JQuery },
	{ code: CDN.PackageCode.Component },
	{ code: CDN.PackageCode.Common },
	{ code: CDN.PackageCode.Map },
	{ code: CDN.PackageCode.API_MapRouting_v1 },
	{ code: CDN.PackageCode.Control_Login, },
	{ code: CDN.PackageCode.Control_Dialog, },
], () => {
	let parent = document.getElementsByTagName("body")[0];
	let loginDiv: HTMLElement = document.createElement('div');
	$(loginDiv).addClass('ms-3 p-2');
	parent.appendChild(loginDiv);

	let logoutDiv: HTMLElement = document.createElement('div');
	$('.navbar > .container').append(logoutDiv);

	var login: CDN.Controls.Login = new CDN.Controls.Login(loginDiv, {
		onError: (err) => {
			console.error(err);
		},
		onLogin: async (result) => {
			if (result.UserToken == null) {
				console.error('Invalid User Token');
				return;
			}
			loggedUserToken = result.UserToken;
			loggedProducts = result.products;

			sessionStorage.setItem('userToken', loggedUserToken);
			sessionStorage.setItem('products', JSON.stringify(loggedProducts));

			login.hide();
			$(loginDiv).addClass('d-none');
			$('#testPanel').removeClass('d-none');
			$(logoutDiv).removeClass('d-none');
		}
	});
	login.hide();

	var $btnLogout: JQuery = $(`<button>logout</button>`);
	$(logoutDiv).append($btnLogout);
	$(logoutDiv).addClass('d-none');
	$btnLogout.click((e) => {
		e.stopPropagation();
		e.preventDefault();

		$(this).prop('disabled', true);
		sessionStorage.setItem('userToken', "");
		sessionStorage.setItem('products', "");

		$(loginDiv).removeClass('d-none');
		login.show();
		$('#testPanel').addClass('d-none');
		$(logoutDiv).addClass('d-none');
		$(this).prop('disabled', false);
		location.reload();
	});

	if (sessionStorage.getItem('userToken') != null && sessionStorage.getItem('userToken') != ""
		&& sessionStorage.getItem('products') != null && sessionStorage.getItem('products') != "") {
		loggedUserToken = sessionStorage.getItem('userToken');
		loggedProducts = JSON.parse(sessionStorage.getItem('products'));

		$(loginDiv).addClass('d-none');
		$('#testPanel').removeClass('d-none');
	} else {
		/* show login */
		login.show();
		$(loginDiv).removeClass('d-none');
		$('#testPanel').addClass('d-none');
	}

	$('#sourceList').addClass('d-none');
	let div = document.getElementById('mapPanel');
	$(div).css("height", "760px");
	routeMapElement = new CDN.Map.Map(div);
	$(div).closest('.container').removeClass('container').addClass('p-2');
	/* Add new button */
	let btnPrevPos = document.createElement('button')
	btnPrevPos.className = 'btn btn-warning btn-pos-change prev disabled';
	btnPrevPos.innerHTML = 'Prev Pos';
	btnPrevPos.id = "prevPos";
	$('#back').parent().append(btnPrevPos);
	let btnNextPos = document.createElement('button')
	btnNextPos.className = 'btn btn-warning btn-pos-change next ms-1 disabled';
	btnNextPos.innerHTML = 'Next Pos';
	btnNextPos.id = "nextPos";
	$('#back').parent().append(btnNextPos);

	$('#addLayer').click(function (e) {
		e.preventDefault();
		var points: any = JSON.parse($('#sourceData').val());
		let color = $('#layerColor').val();
		let lineColor = $('#lineColor').val();
		let requestLayer = $('#srcLayer').val();
		if (points == '') {
			return;
		}
		if ($('#parseRoadSegments').is(':checked')) {
			showCoords(points);
			return;
		}
		showLayer(points, requestLayer, color, lineColor);
	});

	$('#clear').click(function (e) {
		routeMapElement.clear();
	});

	$('#parseRoadSegments').click(function (e) {
		if ($(this).is(':checked')) {
			$('#processBulkLayers').addClass('hide');
		} else {
			$('#processBulkLayers').removeClass('hide');
		}
	});

	/*
	$('#processBulkLayers2').click(async (e) => {
		e.preventDefault();
		routeMapElement.clear();
		layerGroups = [];
		layerGroupPos = 0;
		lastGroupToggle = 'all';
		let inputOffset: any = $('#sourceData').val();
		if (inputOffset == '') {
			$('#sourceData').focus();
			alert('Enter offset value');
			return;
		}
		if (inputOffset != '' && inputOffset != srcOffset) {
			srcOffset = Number(inputOffset);
			offset = Number(inputOffset);
		} else {
			offset += 5;
		}
		$('#processBulkLayers').addClass('disabled').prop('disabled', true);
		let trips: CDN.API.MapRouting.v1.TripRouteTest[] = await CDN.API.MapRouting.v1.getRouteTripsTestAsync({
			userToken: loggedUserToken,
			productId: CDN.Common.ProductId.Supreme
		}, offset, 5);
		$('#processBulkLayers').removeClass('disabled').prop('disabled', false);
		if (trips.length > 0) {
			$('.loaded-trips-info').text(`Trips loaded from Id ${trips[0].Id} to Id ${trips[trips.length - 1].Id}. Total trips ${trips.length}`);
		} else {
			$('.loaded-trips-info').text("No trips loaded.");
		}
		for (let trip of trips) {
			layerGroups.push({
				id: trip.Id,
				old: JSON.parse(trip.RefTripRoute),
				newv2: JSON.parse(trip.TripRouteV2),
				registration: trip.Registration,
				positions: trip.Positions,
				datetime: trip.DateTime.format('yyyy-MM-dd HH:mm.ss'),
				newv1: JSON.parse(trip.TripRouteV1),
				RefTripRouteTest_Id: trip.RefTripRouteTest_Id
			});
		}
		showLayerGroup();
	});
	*/

	$('#processBulkLayers').click(function (e) {
		e.preventDefault();
		routeMapElement.clear();
		layerGroups = [];
		layerGroupPos = 0;
		lastGroupToggle = 'all';
		var layers: any = $('#sourceData').val();
		if (layers == '') {
			return;
		}
		let layerSets: string[] = layers.split('##$');
		let k: number = 1;
		for (let i in layerSets) {
			let layerSet: string = layerSets[i];
			let records: string[] = layerSet.split('@@$');
			if (records.length != 2) {
				/*invalid data*/
				continue;
			}
			layerGroups.push({
				id: k,
				old: JSON.parse(records[0]),
				newv2: JSON.parse(records[1])
			});
			k++;
		}
		showLayerGroup();
	});
	$('#backwardLayers').click(function (e) {
		e.preventDefault();
		if (layerGroupPos == 0) {
			/* min limit reached */
			alert('Start position reached already!')
			return;
		}
		layerGroupPos -= 1;
		routeMapElement.clear();
		showLayerGroup();
	});
	$('#forwardLayers').click(function (e) {
		e.preventDefault();
		if (layerGroupPos == (layerGroups.length - 1)) {
			/* max limit reached */
			alert('End position reached already!')
			return;
		}
		layerGroupPos += 1;
		routeMapElement.clear();
		showLayerGroup();
	});
	$('#toggleLayers').click(function (e) {
		e.preventDefault();
		routeMapElement.clear();
		switch (lastGroupToggle) {
			case 'all':
				lastGroupToggle = 'old';
				break;
			case 'old':
				lastGroupToggle = 'new_v1';
				break;
			case 'new_v1':
				lastGroupToggle = 'new_v2';
				break;
			case 'new_v2':
				lastGroupToggle = 'all';
				break;
		}
		showLayerGroup(false);
	});
	$('.btn-pos-change').click(function (e) {
		if ($(this).hasClass('disabled') || mapCirclePositions.length == 0) {
			return;
		}
		if ($(this).hasClass('prev')) {
			/* goto previous */
			currentPos = (currentPos > 0) ? (currentPos - 1) : 0;
		} else {
			/* goto next */
			currentPos = (currentPos == mapCirclePositions.length - 1) ? currentPos : (currentPos + 1);
		}
		if (lastSourceId == "" && currentPos == 1) {
			currentPos = 0;
		}
		if (currentPos == 0) {
			$('#prevPos').addClass('disabled');
			$('#nextPos').removeClass('disabled');
		} else if (currentPos == mapCirclePositions.length - 1) {
			$('#prevPos').removeClass('disabled');
			$('#nextPos').addClass('disabled');
		} else {
			$('#prevPos').removeClass('disabled');
			$('#nextPos').removeClass('disabled');
		}
		if (lastSourceId != "") {
			routeMapElement.removeSource(lastSourceId);
			lastSourceId = "";
		}
		lastSourceId = appendToTestMap('circle', [mapCirclePositions[currentPos]], true, '#6ddc00', '#6ddc00', false, 10);
	});
});

function showLayerGroup(setCenter: boolean = true) {
	let layerGroup = layerGroups[layerGroupPos];
	let toggle = lastGroupToggle;
	let tripId: any = layerGroup.id;
	if (toggle == 'old' || toggle == 'all') {
		showLayer(layerGroup.old, $('#srcLayer').val(), '#ff0000', '#42a1ff', (toggle == 'all') ? false : setCenter);
	}
	let skipV2: boolean = false;
	if (toggle == 'new_v1' || toggle == 'all') {
		if (layerGroup?.newv1) {
			showLayer(layerGroup.newv1, $('#srcLayer').val(), '#00b33e', '#ff7300', setCenter);
			tripId += `(Old Id: ${layerGroup.RefTripRouteTest_Id})`;
		} else {
			if (toggle == 'new_v1') {
				lastGroupToggle = 'new_v2';
			}
			skipV2 = true;
			showLayer(layerGroup.newv2, $('#srcLayer').val(), '#00b33e', '#ff7300', setCenter);
		}
	}
	if ((toggle == 'new_v2' || toggle == 'all') && !skipV2) {
		showLayer(layerGroup.newv2, $('#srcLayer').val(), '#9300bd', '#3dae00', setCenter);
	}
	$('#testPanel .sub-title').text(tripId);
	if (layerGroup?.datetime && layerGroup?.registration) {
		$('#testPanel .label-additional-info').text(`${layerGroup?.registration} - ${layerGroup?.datetime}`);
	}
	if (layerGroup?.positions) {
		let options: CDN.Map.FeatureOptions[] = [];
		let routeSegments = layerGroup.positions;
		for (let key in routeSegments) {
			let routeSegment: CDN.API.Area.v1.PointSegment = routeSegments[key];
			let posType = (key == '0') ? '17' : '18';
			if (routeSegments[Number(key) + 1] == undefined) {
				/* last point */
				posType = '20';
			}
			let position: CDN.Map.FeatureOptions = {
				id: "veh_pos_" + key,
				position: [routeSegment.Lon, routeSegment.Lat],
				direction: routeSegment.Direction,
				posType: posType,
				popup: {
					on: 'click',
					html: `<br><br>${routeSegment.Lon}, ${routeSegment.Lat}`
				}
			};
			options.push(position);
		}
		appendToTestMap('arrow', options, true, '#003ecc', '#003ecc', false, 7);
	}
	$('#toggleStatus').text(`${toggle} - ${layerGroup.id}`);
}

function showLayer(points: any[], requestLayer: string, color: string, lineColor: string, setCenter: boolean = true) {
	let featureOptions: CDN.Map.FeatureOptions[] = [];
	let coordinates: string[] = [];
	mapCirclePositions = [];
	currentPos = 0;
	if (lastSourceId != "") {
		routeMapElement.removeSource(lastSourceId);
		lastSourceId = "";
	}
	$('#prevPos').addClass('disabled');
	$('#nextPos').addClass('disabled');
	let id: number = 1;
	let circlePos: number = 0;
	for (let i in points) {
		let point: any = points[i];
		let geomStr: string = point.ls;
		let records: string[] = geomStr.split(',');
		for (let record of records) {
			let lastCoordinate = coordinates[coordinates.length - 1];
			if (lastCoordinate == record) {
				/* coordinate exists already in the previous option */
				continue;
			}
			coordinates.push(record);
			let lnglat: string[] = record.split(' ');
			let option: CDN.Map.FeatureOptions = {
				id: `point_${id}`,
				position: [Number(lnglat[0]), Number(lnglat[1])],
				popup: {
					on: 'click',
					html: `<br><br>${lnglat[0]}, ${lnglat[1]}`
				}
			};
			featureOptions.push(option);
			id++;
		}
		if (point.hasOwnProperty('lonlat')) {
			let lnglat: string[] = point.lonlat.split(' ');
			let pointPos: number = circlePos;
			mapCirclePositions.push({
				id: `pos_lnglat_${pointPos}`,
				position: [Number(lnglat[0]), Number(lnglat[1])],
				popup: {
					on: 'click',
					callbackAsync: async () => {
						if (pointPos > 0) {
							currentPos = pointPos - 1;
							$('#nextPos').click();
						} else {
							currentPos = pointPos + 1;
							$('#prevPos').click();
						}
						return `<br><br>${lnglat[0]}, ${lnglat[1]}`;
					}
				}
			});
		}
		circlePos++;
	}
	appendToTestMap(requestLayer, featureOptions, true, color, lineColor, setCenter);
	if (mapCirclePositions.length > 0) {
		/*$('#nextPos').removeClass('disabled');
		appendToTestMap('circle', mapCirclePositions, true, color, lineColor, setCenter, 8);*/
	}
}

function showSegments(points: any[]) {
	let id: number = 1;
	let setCenter: boolean = true;
	for (let i in points) {
		let point: any = points[i];
		let geomStr: string = point.ls;
		let records: string[] = geomStr.split(',');
		let featureOptions: CDN.Map.FeatureOptions[] = [];
		for (let record of records) {
			let lnglat: string[] = record.split(' ');
			let option: CDN.Map.FeatureOptions = {
				id: `point_${id}`,
				position: [Number(lnglat[0]), Number(lnglat[1])],
				popup: {
					on: 'click',
					html: `<br>Segment Id: ${point.id}`
				}
			};
			featureOptions.push(option);
			id++;
		}
		let color: string = getRandDarkColor();
		let lineColor: string = adjustColor(color, 130);
		appendToTestMap('circle-line', featureOptions, false, color, lineColor, setCenter);
		setCenter = false;
	}
}

function showCoords(points: any[]) {
	let id: number = 1;
	let featureOptions: CDN.Map.FeatureOptions[] = [];
	for (let i in points) {
		let lnglat: string[] = points[i];
		let option: CDN.Map.FeatureOptions = {
			id: `point_${id}`,
			position: [Number(lnglat[0]), Number(lnglat[1])],
			popup: {
				on: 'click',
				html: `${lnglat[0]},${lnglat[1]}`
			}
		};
		featureOptions.push(option);
		id++;
	}
	let color: string = getRandDarkColor();
	let lineColor: string = adjustColor(color, 130);
	appendToTestMap('circle-line', featureOptions, false, color, lineColor, true);
}

function getRandDarkColor() {
	var color = '#';
	for (var i = 0; i < 6; i++) {
		color += Math.floor(Math.random() * 10);
	}
	return color;
}

function getRandLightColor() {
	var letters = 'BCDEF'.split('');
	var color = '#';
	for (var i = 0; i < 6; i++) {
		color += letters[Math.floor(Math.random() * letters.length)];
	}
	return color;
}

function adjustColor(color, amount) {
	return '#' + color.replace(/^#/, '').replace(/../g, color => ('0' + Math.min(255, Math.max(0, parseInt(color, 16) + amount)).toString(16)).substr(-2));
}

function appendToTestMap(requestLayer: string, points: CDN.Map.FeatureOptions[], overlap: boolean = false, color: string = '#007fd9', lineColor: string = '#484848', setCenter: boolean = true, radius: number = 5) {
	let sourceId = 'map_source_' + new Date().getTime();
	let coordinates: number[][] = [];
	let collection = new CDN.Map.FeatureCollection();
	for (let idx in points) {
		let point = points[idx];
		point['color'] = color;
		point['lineColor'] = lineColor;
		point['radius'] = radius;
		if (requestLayer == 'arrow' || requestLayer == 'arrow-line' || requestLayer == 'circle' || requestLayer == 'circle-line') {
			let feature: CDN.Map.GeoJsonFeature = new CDN.Map.GeoJsonFeature({ type: 'Point', coordinates: point.position }, point);
			feature.id = point.id;
			collection.addFeature(feature);
		}
		coordinates.push(point.position);
	}

	if (requestLayer == 'arrow' || requestLayer == 'arrow-line') {
		/* prepare arrow layer */
		let source = new CDN.Map.GeoJsonSource(collection);
		let srcId = sourceId;
		let options: CDN.Map.LayerOptions = { overlap: overlap, iconsize: 0.14 };
		let layerId = srcId + '_layer';
		routeMapElement.addLayerAsync(source, new CDN.Map.SymbolLayer(layerId, srcId, options))
		.then((result) => {
			if (routeMapElement.hasSource(srcId) && setCenter) {
				if (requestLayer != 'arrow-line') {
					routeMapElement.setCenter(12, source);
				}
			}
			routeMapElement.movePinLayer();
			if (overlap) {
				routeMapElement.moveLayer(layerId);
			}
		});
	}

	if (requestLayer == 'circle' || requestLayer == 'circle-line') {
		/* prepare circle layer */
		let source = new CDN.Map.GeoJsonSource(collection);
		let srcId = sourceId;
		if (requestLayer == 'circle-line') {
			srcId = sourceId + '_circle';
		}
		let options: CDN.Map.LayerOptions = { overlap: overlap, radius: 3 };
		routeMapElement.addLayerAsync(source, new CDN.Map.CircleLayer(srcId + '_layer', srcId, options))
		.then((result) => {
			if (routeMapElement.hasSource(srcId) && setCenter) {
				routeMapElement.setCenter(12, source);
			}
			routeMapElement.movePinLayer();
		});
	}

	if (requestLayer == 'line' || requestLayer == 'arrow-line' || requestLayer == 'circle-line') {
		/* prepare line layer */
		if (lineColor === undefined) {
			lineColor = color;
		}
		let feature = new CDN.Map.GeoJsonFeature({ type: 'LineString', coordinates: coordinates }, { lineColor: lineColor });
		let source = new CDN.Map.GeoJsonSource(feature);
		let srcId = sourceId;
		if (requestLayer == 'arrow-line') {
			srcId = sourceId + '_line';
		}
		routeMapElement.addLayerAsync(source, new CDN.Map.LineLayer(srcId + '_layer', srcId))
		.then((result) => {
			if (routeMapElement.hasSource(srcId)) {
				if (setCenter) {
					routeMapElement.setCenter(12, source);
				}
				if (requestLayer == 'arrow-line') {
					routeMapElement.moveLayer(`${sourceId}_layer`);
				} else if (requestLayer == 'circle-line') {
					routeMapElement.moveLayer(`${sourceId}_circle_layer`);
				}
			}
			routeMapElement.movePinLayer();
		});
	}
	return sourceId;
}
